/*
 * @providesModule TextInputComponent
 */

import React, { useEffect, useMemo, useState, forwardRef } from 'react';
import { Text, TextInput, TouchableOpacity, View } from 'react-native';
import styles from 'TextInputComponentStyle';
import { InputProps } from 'TextInputProps'
import SkillzSVG from 'SkillzSVG';

// @ts-ignore
const TextInputComponent: InputProps = forwardRef((props, ref) => {
    const {
        fontFamily,
        style,
        inputStyle,
        iconStyle,
        labelStyle,
        placeholderStyle = {},
        value,
        label,
        secureTextEntry,
        placeholderTextColor = '#000',
        placeholder = '',
        showIcon,
        numeric,
        focusColor,
        labelProps,
        onFocus,
        onBlur,
        onChangeText = (_value: string) => { },
        renderLeftIcon,
        renderRightIcon,
        testID,
    } = props;

    const [text, setText] = useState<string>('');
    const [isFocus, setIsFocus] = useState<boolean>(false);
    const [textEntry, setTextEntry] = useState<boolean>(
        secureTextEntry ? true : false,
    );

    useEffect(() => {
        if (value) {
            if (numeric) {
                setText(formatNumeric(value));
            } else {
                setText(value);
            }
        } else {
            setText("");
        }
    }, [value]);

    const formatNumeric = (num: string) => {
        const values = num.toString().replace(/\D/g, '');
        return values.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const reConvertNumeric = (x: string) => {
        let s;
        s = x.split('.');
        s = s.join('');
        return s;
    };

    const onChange = (text: string) => {
        if (numeric) {
            setText(formatNumeric(text));
            onChangeText(reConvertNumeric(text));
        } else {
            setText(text);
            onChangeText(text);
        }
    };

    const onChangeTextEntry = () => {
        setTextEntry(!textEntry);
    };

    const _renderRightIcon = () => {
        if (showIcon) {
            if (renderRightIcon) {
                return renderRightIcon();
            }
            if (secureTextEntry) {
                return (
                    <TouchableOpacity onPress={onChangeTextEntry}>
                        <SkillzSVG
                            source={textEntry ? 'password_eye.svg' : 'eye-off.svg'}
                            style={[styles.icon, iconStyle]}
                        />
                    </TouchableOpacity>
                );
            }
        }
        return null;
    };

    const font = () => {
        if (fontFamily) {
            return {
                fontFamily: fontFamily,
            };
        } else {
            return {};
        }
    };

    const onFocusCustom = (e: any) => {
        setIsFocus(true);
        if (onFocus) {
            onFocus(e);
        }
    };

    const onBlurCustom = (e: any) => {
        setIsFocus(false);
        if (onBlur) {
            onBlur(e);
        }
    };

    const colorFocus = useMemo(() => {
        if (isFocus && focusColor) {
            return {
                borderBottomColor: focusColor,
                borderTopColor: focusColor,
                borderLeftColor: focusColor,
                borderRightColor: focusColor
            };
        } else {
            return {};
        }
    }, [isFocus]);

    const styleLabel: any = useMemo(() => {
        if (isFocus || text.length > 0 && label) {
            return {
                top: 5,
                color: isFocus ? focusColor : null,
                ...(typeof labelStyle === 'object' ? labelStyle : {})
            };
        } else {
            return {
                position: 'absolute',
                ...(typeof placeholderStyle === 'object' ? placeholderStyle : {})
            }
        }
    }, [isFocus, text, placeholderStyle, labelStyle]);

    return (
        <View style={[styles.container, style, colorFocus]}>
            <View
                style={[
                    styles.textInput,
                ]
                }>
                {renderLeftIcon?.()}
                <View style={styles.inputContainer}>
                    {label ? <Text style={[styles.label, styleLabel]} {...labelProps}>{label}</Text> : null}
                    <TextInput
                        testID={testID}
                        {...props}
                        ref={ref}
                        style={[styles.input, inputStyle, font()]}
                        secureTextEntry={textEntry}
                        value={text}
                        placeholder={isFocus || !label ? placeholder : ''}
                        placeholderTextColor={placeholderTextColor}
                        onChangeText={onChange}
                        onFocus={onFocusCustom}
                        onBlur={onBlurCustom}
                    />
                </View>
                {_renderRightIcon()}
            </View>
        </View>
    );
});

export default TextInputComponent;
